import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLayout } from '../../../../providers/Layout.provider';
import { MastercardP2C } from './MastercardP2C';
import { useToken } from '../../../../providers/Token.provider';
import usePostLinkPushToCardRequest from '../../../../hooks/useApi/usePostLinkPushToCardRequest';
import useStorage from '../../../../hooks/useStorage';

const { IframeLayout, SeparatorMoon, SeparatorImg, Image } = vp;

type FC = FunctionComponent;

type DataProps = {
  method: string;
  origin: string;
};

const MastercardPushToCardContainer: FC = () => {
  const { layout, color, src, height, positionX, positionY, hasBackButton, setLayoutInfo } = useLayout();
  const { token } = useToken();
  const { state } = useLocation<DataProps>();
  const [iFrameUrl, setIFrameUrl] = useState<string>('');
  const [pushToCardMapResponse, callLinkPushToCardRequest] = usePostLinkPushToCardRequest({});
  const storage = useStorage();
  const IframeKey = storage.token.getIQ11Token().iQ11Token;

  useEffect(() => {
    callLinkPushToCardRequest({
      IframeKey,
      Token: '',
      RequestID: '',
      IsPayLinkTransaction: state?.origin === 'token',
    });
  }, []);

  useEffect(() => {
    if (pushToCardMapResponse.Success) {
      setIFrameUrl(pushToCardMapResponse.PushToCardDetails.IframeUrl);
    }
  }, [pushToCardMapResponse]);

  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'moon',
      '',
      80,
      20,
      0,
      true,
      false,
    );
  }, []);

  return (
    <IframeLayout
      separator={
        layout === 'img' ? (
          <SeparatorImg width={100} height={110} fill={color} />
        ) : layout === 'moon' ? (
          <SeparatorMoon width={140} height={110} fill={color} />
        ) : (
          <></>
        )
      }
      image={
        src === '' ? (
          <></>
        ) : (
          <Image width="auto" height={height} positionX={positionX} positionY={positionY} src={src} />
        )
      }
      hasBackButton={hasBackButton}
      content={<MastercardP2C iFrameUrl={iFrameUrl} />}
    />
  );
};

export default MastercardPushToCardContainer;
